var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header'),_vm._v(" "),_c('div',{staticClass:"mt-16"},[_vm._t("default")],2),_vm._v(" "),_c('bottom-footer'),_vm._v(" "),_vm._t("modal")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }